import { RootState } from '../../store/store';

export const selectDesignData = (state: RootState) => state.design.design.designData;
export const selectDesignLoading = (state: RootState) => state.design.design.loading;
export const selectDesignError = (state: RootState) => state.design.design.error;
